// extracted by mini-css-extract-plugin
module.exports = {"container":"spinner_container__3uPF9","unit":"spinner_unit__kr0Hu","spinnerAnimation":"spinner_spinnerAnimation__20vz_"};